import { Slider } from "@mui/material";
import styled from "styled-components";
import { Values } from "../../../../interface/Values";
import { useContext } from "react";
import { GameContext } from "../../../../contexts/GameContext";


interface Props {
    minLabel: string,
    maxLabel: string,
    lowerThreshold: number,
    lowThreshold: number,
    highThreshold: number,
    higherThreshold: number,
    currentScale: number,
    asset: keyof Values | "energy"
}


const ComfortBar = ({ minLabel, maxLabel, lowerThreshold, lowThreshold, highThreshold, higherThreshold, currentScale, asset }: Props) => {
    const { interfaceParams } = useContext(GameContext);

    return (
        <Container>
            <Label>{minLabel}</Label>
            {interfaceParams ? <Slider
                aria-label="Temperature"
                defaultValue={currentScale}
                min={0}
                max={1}
                disabled

                sx={{
                    '& .MuiSlider-rail': {
                        "opacity": "1",
                        "background": `linear-gradient(90deg,
                                    ${interfaceParams["bars"][asset]["gradient"][0]["color"]} 0%,
                                    ${interfaceParams["bars"][asset]["gradient"][0]["color"]} ${lowerThreshold * 100 - 5}%,
                                    ${interfaceParams["bars"][asset]["gradient"][1]["color"]} ${lowerThreshold * 100 + 5}%,
                                    ${interfaceParams["bars"][asset]["gradient"][1]["color"]} ${lowThreshold * 100 - 5}%,
                                    ${interfaceParams["bars"][asset]["gradient"][2]["color"]} ${lowThreshold * 100 + 5}%,
                                    ${interfaceParams["bars"][asset]["gradient"][2]["color"]} ${highThreshold * 100 - 5}%,
                                    ${interfaceParams["bars"][asset]["gradient"][3]["color"]} ${highThreshold * 100 + 5}%,
                                    ${interfaceParams["bars"][asset]["gradient"][3]["color"]} ${higherThreshold * 100 - 5}%,
                                    ${interfaceParams["bars"][asset]["gradient"][4]["color"]} ${higherThreshold * 100 + 5}%,
                                    ${interfaceParams["bars"][asset]["gradient"][4]["color"]} 100%);`},
                    '& .MuiSlider-track': {
                        "opacity": "0",
                    },
                    '& .MuiSlider-thumb': {
                        color: 'black',
                        width: '.4em',
                        borderRadius: '1px',
                        backgroundColor: 'black !important'
                    },
                }}
            /> : null}
            <Label>{maxLabel}</Label>
        </Container>
    );


};


const Container = styled.div`
    display: flex;
    padding: 1em;
`

const Label = styled.div`
    padding: .5em;
    font-size: .8em;
    font-weight: bold;
`


export default ComfortBar;